import apiClient, { unwrapData } from "./apiClient";
import { getLeadContextLeads } from "./leadsApi";

function buildCallsPerDayFromPerformance(items = []) {
  const days = {};
  const today = new Date();

  for (let i = 13; i >= 0; i -= 1) {
    const day = new Date(today);
    day.setDate(day.getDate() - i);
    days[day.toISOString().slice(0, 10)] = 0;
  }

  items.forEach((item) => {
    const key = String(item.call_date || "").slice(0, 10);
    if (key in days) {
      days[key] += Number(item.totalCalls || 0);
    }
  });

  const entries = Object.entries(days);

  return {
    labels: entries.map(([date]) => date.slice(5)),
    values: entries.map(([, count]) => count),
  };
}

export async function getAnalyticsCalls(options = {}) {
  const { signal } = options;
  const fetchOptions = signal ? { signal } : {};

  const [performanceResponse, callsResponse] = await Promise.all([
    apiClient.get("/api/dashboard/call-performance", fetchOptions),
    apiClient.get("/api/calls", {
      ...fetchOptions,
      query: { view: "canonical", limit: 300, page: 1 },
    }),
  ]);

  const performanceData = unwrapData(performanceResponse) || {};
  const callsData = unwrapData(callsResponse) || {};

  return {
    callsPerDay: buildCallsPerDayFromPerformance(
      Array.isArray(performanceData.items) ? performanceData.items : [],
    ),
    rawCalls: Array.isArray(callsData.items) ? callsData.items : [],
  };
}

export async function getAnalyticsLeads(options = {}) {
  return getLeadContextLeads(options);
}
